import Component from './login_form.vue'
export default Component
